// guard
export enum ERolesGuard {
    System_Role = "system_Role",
    Users_Role = "users_Role",
}
export enum EGuard {
    System = "system",
    User = "user",
}

export enum EGender {
    Male = "male",
    Female = "female",
    None = "none",
}

export enum EDay {
    Saturday = "saturday",
    Sunday = "sunday",
    Monday = "monday",
    Tuesday = "tuesday",
    Wednesday = "wednesday",
    Thursday = "thursday",
    Friday = "friday",
}

export enum ERecurring {
    Daily = "daily",
    Weekly = "weekly",
    Monthly = "monthly",
    Yearly = "yearly",
}

export enum EEmployee {
    Employee = "employee",
    Temporary = "temporary",
    Unemployed = "unemployed",
    Volunteer = "volunteer",
    Intern = "intern",
    None = "none",
}

export enum EOtpType {
    All = "all",
    Email = "email",
    SMS = "sms",
}

export enum ELeaveTransactionType {
    Deducted = "deducted",
    Added = "added",
    Cancellation = "cancellation",
    Modification = "modification",
    Rescheduled = "rescheduled",
    Expired = "expired",
}

export enum ELeaveStatus {
    Pending = "pending",
    Reschedule = "reschedule",
    Approved = "approved",
    Rejected = "rejected",
    Waiting = "waiting",
}

export enum EStatus {
    // Very Good
    Active = "active",
    Done = "done",
    Success = "success",
    Completed = "completed",
    Verified = "verified",

    // Good
    Received = "received",
    Approved = "approved",
    Accepted = "accepted",
    Owner = "owner",
    Show = "show",
    Scheduled = "scheduled",
    InStock = "inStock",

    Dispatch = "dispatch",
    OnTheWay = "onTheWay",
    CheckedIn = "checkedIn",
    CheckedOut = "checkedOut",

    // Middle (something in progress or waiting for something)
    NotStarted = "notStarted",
    OnHold = "onHold",
    InQueue = "inQueue",
    Delivered = "delivered",
    Pending = "pending",
    Waiting = "waiting",
    Processing = "processing",
    InProgress = "inProgress",
    Request = "request",

    // Bad
    Failed = "failed",
    NotOwner = "notOwner",
    Disabled = "disabled",
    Warning = "warning",
    Hidden = "hidden",
    ReSchedule = "reSchedule",
    OutOfStock = "outOfStock",

    // Worst
    Suspended = "suspended",
    Blocked = "blocked",
    Declined = "declined",
    Cancel = "cancel",
    Reject = "reject",
}

export enum ESocialMedia {
    Facebook = "Facebook",
    Instagram = "Instagram",
    X = "X",
    TikTok = "TikTok",
}

export enum EAuthProvider {
    None = "none",
    Email = "email",
    Google = "google",
    Facebook = "facebook",
    Apple = "apple",
    GitHub = "github",
}

// events

export enum EEventType {
    Private = "Private",
    Public = "Public",
}

export enum EEventTicketType {
    Free = "Free",
    Pay = "Pay",
}

// tickets
export enum ETicketType {
    VIP = "vip",
    Standard = "standard",
}

export enum ETicketPayment {
    /// <summary>
    ///  Starting in progress
    /// </summary>
    Pending = "pending",
    Paid = "paid",
    NotPaid = "not paid",
}

export enum EPaymentStatus {
    Pending = "pending",
    Paid = "paid",
    Processing = "processing",
    Canceled = "canceled",
}

export enum ETicketPaymentMethod {
    eDahab = "eDahab",
    ZAAD = "ZAAD",
    MasterCard = "MasterCard",
}

//
